module.exports = "<div class=\"dashboard-navigation\" *ngIf=\"tabs.length\">\n  <app-tabs [activeTab]=\"active\" (selected)=\"handleTabClick($event)\">\n    <app-tab *ngFor=\"let tab of tabs; trackBy: tabName\" [tabTitle]=\"tab.title\">\n    </app-tab>\n  </app-tabs>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard-navigation/dashboard-navigation.component.html
// module id = ../../../../../src/app/dashboard/dashboard-navigation/dashboard-navigation.component.html
// module chunks = 2